import { useState } from "react";
import { hotVideos, videoCategories, type VideoItem } from "@/mocks/gossipData";

function VideoCard({ video }: { video: VideoItem }) {
  return (
    <article className="card-lift rounded-xl overflow-hidden group hover:border-primary-200 transition-colors cursor-pointer">
      <div className="relative aspect-video overflow-hidden bg-background-100">
        <img
          src={video.image}
          alt={`${video.title} 吃瓜现场视频封面`}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 rounded-md bg-black/60 backdrop-blur px-2 py-0.5 text-white text-xs">
          {video.duration}
        </span>
        {video.hotTag && (
          <span className="absolute top-2 right-2 rounded-md bg-primary-500 text-background-50 text-xs font-medium px-2 py-0.5 flex items-center gap-1">
            <i className="ri-fire-fill text-accent-300"></i>
            {video.hotTag}
          </span>
        )}
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 mb-3">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-line"></i>
            {video.likes}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-1-line"></i>
            {video.comments}
          </span>
          <span className="ml-auto rounded-md bg-secondary-100 text-secondary-900 px-2 py-0.5 whitespace-nowrap">
            {video.category}
          </span>
        </div>
      </div>
    </article>
  );
}

export default function HotVideos() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? hotVideos : hotVideos.filter((v) => v.category === active);

  return (
    <section id="hot" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6 md:mb-8">
          <div>
            <p className="text-accent-600 font-heading text-sm mb-1">HOT VIDEOS</p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门现场</h2>
            <p className="text-sm text-foreground-600 mt-2">全网热梗名场面，吃瓜群众正在围观</p>
          </div>
          <a
            href="#live"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            去弹幕现场看更热闹 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* 分类筛选 */}
        <div className="flex flex-wrap items-center gap-2 mb-6 md:mb-8">
          {videoCategories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setActive(cat)}
              className={`px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${
                active === cat
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* 视频卡片 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}